import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { useUnsafeTranslation } from '../../../../i18next';

export const Container = styled('div')((p) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  minHeight: '100%',

  textAlign: 'center',
  gap: p.theme.spacing()
}));

export const PageMaintenanceNewRelease = () => {
  const { t } = useUnsafeTranslation();
  return (
    <Container>
      <div>
        <Typography component="h3" variant="h3">
          {t('Dado will be back shortly')}.
        </Typography>
        <br />
        <div>
          {t(
            'Thank you for your patience while we roll out an exciting update!'
          )}
        </div>
        <div>
          {t(
            'Notifications will still be sent to employees during this time; and employees will still be able to complete their tasks.'
          )}
        </div>
      </div>
    </Container>
  );
};
